import { PRODUCT_FAMILY_OPTIONS as DEVICE_CONTENT_GATE_PRODUCT_FAMILY_OPTIONS } from "@jti/ui/components/DeviceContentGate/productFamily";

export type ArrayElement<ArrayType extends readonly unknown[]> = ArrayType[number];

export const INTERNAL_HREF_PATTERN: ArrayElement<Inputs>["regex"] = {
  pattern: `^/.*`,
  options: "g",
  message: "You must use href starting with '/...' ",
};

export const IMAGE_FILE_TYPES = ["jpeg", "jpg", "png", "gif", "svg", "webp"];

export const VIDEO_FILE_TYPES = ["mp4", "mov"];

export const VIDEO_MIME_TYPE_ENUM = [
  { label: "WebM (video/webm)", value: "video/webm" },
  { label: "MP4 (video/mp4)", value: "video/mp4" },
  { label: "OGG (video/ogg)", value: "video/ogg" },
  { label: "MOV (video/quicktime)", value: "video/quicktime" },
  { label: "AVI (video/x-msvideo)", value: "video/x-msvideo" },
];

export const PRODUCTS_BINDING = {
  "component.options.products": "state.products",
} as const;

export const PRODUCTS_BINDING_INPUT = {
  name: "products",
  type: "object",
} as const;

export const DEFAULT_IMAGE =
  "https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F72c80f114dc149019051b6852a9e3b7a";

export const DEFAULT_IMAGE_ASPECT_RATIO = 1.5;

export const DEFAULT_IMAGE_MAX_WIDTH = 1920;

export const BUILDER_FRAME_EDITING_SEARCH_PARAM = "builder.frameEditing";

export const BUILDER_TEXT_CLASSNAME = "builder-text";

export const PRODUCT_FAMILY_OPTIONS = DEVICE_CONTENT_GATE_PRODUCT_FAMILY_OPTIONS;
